<template>

  <!-- XOL-606: at xs / sm / md (vue-mq keys are upper bounds: a 375px phone is `sm`) the five
       percentage-width columns below leave the 130px input-number covering "Page:" and the next
       arrow (a 12.5% column is about 33px there), so the toolbar is one flex row that sizes to
       its content and only wraps below about 205px. The visible "Page:" is dropped (the input
       keeps Element's standard mini width and its accessible name "Page" replaces the text), so
       the whole toolbar fits one line at 320px. At lg / hg the row of columns is unchanged. -->
  <div v-if="isMediumOrLess" class="pdf-toolbar--narrow">
    <el-button type="text" aria-label="Previous page" :disabled="!(pageCount > 1 && currentPage > 1)"
      @click="currentPage > 0 ? currentPage -= 1 : currentPage = 1">
      <i class="fa fa-caret-left" aria-hidden="true"></i>
    </el-button>

    <el-input-number
      v-model="currentPage"
      :min="1"
      :max="pageCount"
      size="mini"
      label="Page" />

    <span class="pdf-toolbar__total">/ <b>{{pageCount}}</b></span>

    <el-button :disabled="!(pageCount > 1 && currentPage < pageCount)"
      type="text" aria-label="Next page" @click="currentPage < pageCount ? currentPage += 1 : currentPage = 1">
      <i class="fa fa-caret-right" aria-hidden="true"></i>
    </el-button>
  </div>

  <el-row v-else type="flex" justify="center" align="middle">

    <el-col :span="1" align="right">
      <el-button type="text" aria-label="Previous page" :disabled="!(pageCount > 1 && currentPage > 1)"
        @click="currentPage > 0 ? currentPage -= 1 : currentPage = 1">
        <i class="fa fa-caret-left" aria-hidden="true"></i>
      </el-button>
    </el-col>

    <el-col :span="2" align="right">
      Page:&nbsp;
    </el-col>
    <el-col :span="3" align="center">
      <el-input-number
      v-model="currentPage"
      :min="1"
      :max="pageCount"
      size="mini"
      label="Page" />
    </el-col>
    <el-col :span="2" align="left">
      &nbsp;/ <b>{{pageCount}}</b>
    </el-col>

    <el-col :span="1" align="center">
      <el-button :disabled="!(pageCount > 1 && currentPage < pageCount)"
        type="text" aria-label="Next page" @click="currentPage < pageCount ? currentPage += 1 : currentPage = 1">
        <i class="fa fa-caret-right" aria-hidden="true"></i>
      </el-button>
    </el-col>
</el-row>

</template>

<style scoped>
  .pdf-toolbar--narrow {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    gap: 4px 8px;
    padding: 4px 0;
  }
  .pdf-toolbar--narrow .el-button {
    margin-left: 0;
  }
  .pdf-toolbar__total {
    white-space: nowrap;
  }
</style>


<script>

export default {

  props: {
    value: {
      required: true
    },

    totalPages: {
      type: Number,
      required: true
    }
  },

  watch: {

    value: function (pg) {
      this.currentPage = pg
    },

    currentPage: function (pg) {
      this.currentPage = pg
      this.$emit('input', pg)
    },

    totalPages: function (tp) {
      this.pageCount = tp
    }

  },

  data () {
    return {
      currentPage: this.value,
      pageCount: this.totalPages
    }
  }
}
</script>
